<template>
  <div>
    <div v-if="spinnerController" class="content-loading">
      <base-loading color="var(--default)" />
    </div>

    <div v-else class="content">
      <div class="content__title-buttons" v-if="showContent">
        <base-title title="">
          <base-button
            @click="drawers.sort.open = !drawers.sort.open"
            text="Filtrar avaliações"
            :class="!!isMobile ? 'reverse w-100 mb_15' : 'ml_15'"
            design="two"
          >
            <p class="filter" v-if="!isMobile">
              <i class="fal fa-sliders-h"></i>
            </p>
            <p class="filter" v-else>Filtro e condições</p>
          </base-button>
          <base-button
            @click="drawers.period.open = !drawers.period.open"
            title="Definir periodo"
            :class="!!isMobile ? 'reverse w-100 mb_15' : 'ml_15'"
            design="two"
          >
            <p class="filter" v-if="!isMobile">
              <i class="fal fa-calendar-day"></i>
            </p>
            <p class="filter" v-else>Filtrar intervalo</p>
          </base-button>
        </base-title>
      </div>

      <base-box :class="!isMobile && 'mb_40'">
        <div class="d-flex justify-between align-center mb_5 flex-wrap">
          <div class="d-flex align-center">
            <base-label text="Buscar cliente" class="mb_0" />

            <span class="tag period" v-if="!noPeriod && !isMobile">
              {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
              <i @click="removePeriod" class="fal fa-times remove-filter"></i>
            </span>
            <span class="tag period" v-if="selectedSource > 0 && !isMobile">
              Cadastrados
              {{ selectedSource == 1 ? 'no Atendimento' : 'na Loja online' }}
              <i
                @click="removeFilterSource"
                class="fal fa-times remove-filter"
              ></i>
            </span>
          </div>
          <span class="tag">{{ result.total }} ocorrências</span>

          <span class="tag period" v-if="!noPeriod && !!isMobile">
            {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
            <i @click="removePeriod" class="fal fa-times remove-filter"></i>
          </span>
          <span class="tag period" v-if="selectedSource > 0 && !!isMobile">
            Cadastrados
            {{ selectedSource == 1 ? 'no Atendimento' : 'na Loja online' }}
            <i
              @click="removeFilterSource"
              class="fal fa-times remove-filter"
            ></i>
          </span>
        </div>

        <base-input
          :placeholder="'Procure por cliente ou telefone.'"
          class="w-100 mb_0"
          v-model="term"
          @keyup="loading = true"
          @input="isTyping = true"
        />
        <div v-if="isMobile && showTags" class="tags-mobile mt_15">
          <p class="tag">{{ result.total }} ocorrências</p>
          <p class="tag" v-if="!noPeriod">
            {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
          </p>
        </div>
      </base-box>

      <div v-if="loading" class="search-loading">
        <base-loading />
      </div>

      <div class="row" v-else>
        <base-empty
          v-if="!showContent"
          title="Você ainda não tem clientes cadastrados."
          message="Todos os seus clientes irão aparecer aqui."
        />
        <div
          v-else
          v-for="(item, index) in result.data"
          :key="index"
          class="col-lg-4 col-md-6 col-xs-12 box-negative"
          :class="!isMobile && 'box-format'"
          @click="customerDetail(item)"
        >
          <base-box class="box-order">
            <div class="header">
              <p class="field-title customer-name">
                {{ item.name ? item.name : 'Não informado' }}
                <verified-badge title="Cliente Online" :type="item.type">
                </verified-badge>
              </p>
            </div>
            <div class="d-flex align-center justify-between mb_25">
              <div>
                <p class="field-title">Telefone</p>
                <p>
                  {{
                    item.phone
                      ? Utils.phoneMask(String(item.phone))
                      : 'Não informado'
                  }}
                </p>
              </div>
              <div class="text-right">
                <p class="field-title">Aniversário</p>
                <p>
                  {{
                    item.birthdate
                      ? dayjs(item.birthdate).format('DD/MM/YYYY')
                      : 'Não informado'
                  }}
                </p>
              </div>
            </div>
            <div class="d-flex align-center justify-between mb_25">
              <div>
                <p class="field-title">Cliente desde</p>
                <p>{{ dayjs(item.created_at).format('DD/MM/YYYY') }}</p>
              </div>
              <!-- OCB
              <div class="text-right">
                <p class="field-title">Cashback atual</p>
                <p>
                  {{
                    item.cashback > 0
                      ? Utils.convertMoney(item.cashback)
                      : "R$ 0,00"
                  }}
                </p>
              </div>
              FIM OCB -->
              <div>
                <p class="field-title">Pedidos</p>
                <p class="text-right">{{ item.orders }}</p>
              </div>
            </div>
            <div class="row m_0">
              <div class="col-lg-6 col-xs-6 p_0">
                <p class="field-title">Total gasto</p>
                <p>{{ Utils.convertMoney(item.total_amount) }}</p>
              </div>
              <div class="col-lg-6 col-xs-6 p_0 text-right">
                <p class="field-title">Ticket médio</p>
                <p>{{ Utils.convertMoney(item.avarage) }}</p>
              </div>
            </div>
          </base-box>
        </div>
      </div>

      <infinite-loading spinner="wavedots" @infinite="infiniteHandler">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>

      <filter-period
        :open="drawers.period.open"
        :close="drawers.period.close"
        @filter="filterPeriod"
        :maxCustomRange="0"
      />

      <base-drawer
        title="Filtros e condições"
        :open="drawers.sort.open"
        :close="drawers.sort.close"
      >
        <!-- OCB <base-card>
          <base-label text="Origem do cadastro" class="mb_15" />
          <base-select class="mb_0" v-model="should">
            <option :value="'0'" selected>Todos</option>
            <option :value="'ATENDIMENTO'">Atendimento</option>
            <option :value="'ONLINE'">Loja online</option>
          </base-select>
        </base-card> OCB -->

        <base-card>
          <base-label text="Ordenar por" class="mb_15" />
          <base-select class="mb_0" v-model="sort">
            <option :value="0" selected>Mais recentes</option>
            <!-- Default -->
            <!-- <option :value="1">Maior cashback atual</option> -->
            <option :value="2">Maior valor gasto</option>
            <option :value="3">Maior quantidade de pedidos</option>
            <option :value="4">Maior ticket médio</option>
          </base-select>
        </base-card>

        <template v-slot:footer>
          <base-button text="Aplicar" class="w-100" @click="sorting" />
        </template>
      </base-drawer>

      <!-- Customer drawer -->
      <sales-customer-drawer
        :index="drawers.customer.index"
        :open="drawers.customer.open"
        :customers="selectedCustomer"
        :customer="selectedCustomer"
        :storeConfigurations="configurations"
      />
    </div>
  </div>
</template>
<script>
import BaseTitle from '@/components/Title';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseEmpty from '@/components/Empty';
import BaseButton from '@/components/Button';
import BaseDrawer from '@/components/Drawer';
import BaseCard from '@/components/Card';
import BaseCheckbox from '@/components/Checkbox';
import BaseQuestion from '@/components/Question';
import BaseSelect from '@/components/Select';
import BaseLabel from '@/components/Label';
import BaseLoading from '@/components/Loading';
import Customer from '@/containers/Customer';
import SalesCustomerDrawer from '@/containers/Sales/SalesCustomerDrawer';
import SalesCustomer from '@/containers/Sales/SalesCustomer/SalesCustomer';
import SalesCustomerForm from '@/containers/Sales/SalesCustomer/SalesCustomerForm';
import SalesSelectCustomer from '@/containers/Sales/SalesCustomer/SalesSelectCustomer';
import VerifiedBadge from '@/containers/Users/VerifiedBadge';

import FilterPeriod from '@/containers/FilterPeriod';
import ApiReports from '@/api/reports';
import CustomerApi from '@/api/customer';

import { getXAPIEnv } from '@/plugins/account';
import { DateTime } from 'easyjs/lib/Tools';
import { Role } from 'easyjs/lib/Role/Group';
import { UserFlag } from 'easyjs/lib/Schema/Account/UserFlag';
import Utils from '@/utils';
import dayjs from 'dayjs';

import InfiniteLoading from 'vue-infinite-loading';

import { mapState } from 'vuex';

export default {
  data() {
    return {
      spinnerController: true,
      loading: false,
      Utils,
      dayjs,
      Role,
      showTags: false,
      isTyping: false,
      page: 1,
      size: 15,
      term: '',
      drawers: {
        period: {
          open: false,
          close: false,
        },
        sort: {
          open: false,
          close: false,
        },
        customer: {
          open: false,
          close: false,
          show: false,
        },
      },
      result: {},
      period: ['1900-01-01', dayjs().format('YYYY-MM-DD')],
      noPeriod: true,
      sort: 0,
      selectedSort: 0,
      selectedSource: 0,
      sortData: {
        created_at: {
          order: 'desc',
        },
      },
      should: '0',
      shouldData: [
        {
          match: {
            type: 'M',
          },
        },
        {
          match: {
            type: 'L',
          },
        },
        {
          match: {
            type: 'F',
          },
        },
      ],
      sortLabel: [
        'mais recentes',
        /* 'maior cashback atual', */
        'maior valor gasto',
        'maior quantidade de pedidos',
        'maior ticket médio',
      ],
      selectedCustomer: {},
      showContent: false,
    };
  },
  components: {
    BaseTitle,
    BaseBox,
    BaseInput,
    BaseEmpty,
    BaseButton,
    BaseDrawer,
    BaseCard,
    BaseCheckbox,
    BaseQuestion,
    BaseSelect,
    BaseLabel,
    BaseLoading,
    Customer,
    SalesCustomer,
    SalesCustomerForm,
    SalesSelectCustomer,
    SalesCustomerDrawer,
    FilterPeriod,
    InfiniteLoading,
    SalesCustomer,
    VerifiedBadge,
  },
  mounted() {
    this.spinner();
  },

  methods: {
    spinner() {
      this.spinnerController = false;
    },
    formatDate(date) {
      const ds = date.split('T');
      return dayjs(dayjs(`${ds[0]} ${ds[1].split('-')[0]}`)).format(
        'HH:mm [de] DD/MM/YYYY'
      );
    },
    search(reset = true) {
      const self = this;
      return new Promise((resolve) => {
        if (reset) {
          this.result.total = 0;
          this.result.data = [];
          this.page = 1;
          this.loading = true;
        }
        ApiReports.reports(this.esDataFilter).then((response) => {
          if (response.data[0]) {
            const data = response.data[0];
            if (data.hits.length > 0) {
              const result = {
                total: data.total.value,
              };
              self.result = { ...self.result, ...result };
              !self.result.data || reset ? (self.result.data = []) : '';

              self.page += 1;

              data.hits.forEach((item) => {
                self.result.data.push(item._source);
              });

              resolve(true);
            } else {
              resolve(false);
            }
          } else {
            resolve(false);
          }
        });
        this.loading = false;
        self.$forceUpdate();
      });
    },
    async infiniteHandler($state) {
      await this.search(false).then((result) => {
        if (result) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    async filterPeriod(period) {
      this.noPeriod = false;
      this.period = period.periods;
      period.periods[0] = dayjs(period.periods[0]).format(
        'YYYY-MM-DDTHH:mm:ssZ[Z]'
      );
      period.periods[1] = dayjs(period.periods[1]).format(
        'YYYY-MM-DDTHH:mm:ssZ[Z]'
      );
      await this.search();
      this.drawers.period.close = !this.drawers.period.close;
    },
    async removePeriod() {
      this.noPeriod = true;
      this.period = ['1900-01-01', dayjs().format('YYYY-MM-DD')];
      await this.search();
    },
    async sorting() {
      this.selectedSort = this.sort;

      switch (parseInt(this.sort) || this.should) {
        case '0':
          this.selectedSource = 0;
          this.shouldData = [
            { match: { type: 'M' } },
            { match: { type: 'L' } },
            { match: { type: 'F' } },
          ];
          break;
        case 'ATENDIMENTO':
          this.selectedSource = 1;
          this.shouldData = [{ match: { type: 'L' } }];
          break;
        case 'ONLINE':
          this.selectedSource = 2;
          this.shouldData = [
            { match: { type: 'F' } },
            { match: { type: 'M' } },
          ];
          break;
        case 0:
          this.sortData = { created_at: { order: 'desc' } };
          break;
        case 1:
          this.sortData = { cashback: { order: 'desc' } };
          break;
        case 2:
          this.sortData = { total_amount: { order: 'desc' } };
          break;
        case 3:
          this.sortData = { orders: { order: 'desc' } };
          break;
        case 4:
          this.sortData = { avarage: { order: 'desc' } };
          break;
        default:
          this.sortData = { created_at: { order: 'desc' } };
          this.shouldData = this.shouldData = [
            { match: { type: 'M' } },
            { match: { type: 'L' } },
            { match: { type: 'F' } },
          ];
      }

      await this.search();
      this.drawers.sort.close = !this.drawers.sort.close;
    },
    removeFilterSource() {
      this.should = '0';
      this.sorting();
    },
    async customerDetail(customer) {
      this.selectedCustomer = customer;
      await this.getAddresses(String(customer.user_id));
      this.drawers.customer.open = !this.drawers.customer.open;
    },
    async getAddresses(userId, index = '') {
      await CustomerApi.GetConfigurations(userId, false).then(
        (configurations) => {
          let addressesData = configurations.getData({
            addresses: [],
          }).addresses;
          this.$set(this.selectedCustomer, 'addresses', addressesData);

          const environmentAlias = getXAPIEnv();
          const { flags, annotations } = configurations.getData({
            flags: { [environmentAlias]: 0 },
          });
          const userFlags = flags[environmentAlias];

          if (annotations && annotations.length) {
            this.annotationsList = annotations
              .map((annotation) => annotation.annotation)
              .join('\n');
          }

          this.hasOrder =
            (userFlags & UserFlag.HAS_ORDER) == UserFlag.HAS_ORDER;
          this.hasAnnotation =
            (userFlags & UserFlag.HAS_ANNOTATION) == UserFlag.HAS_ANNOTATION;
          this.isBirthday =
            (userFlags & UserFlag.IS_BIRTHDAY) == UserFlag.IS_BIRTHDAY;
          this.hasIndicator =
            !this.hasOrder || this.hasAnnotation || this.isBirthday;

          if (addressesData.length > 0) {
            this.selectedDeliveryAddress = 0;
          }

          if (index != '') {
            this.selectedDeliveryAddress = index;
          }

          this.$set(
            this.selectedCustomer,
            'annotation',
            configurations.getData({ annotations: [null] }).annotations[0]
          );
        }
      );
    },
    removeAddress(id) {
      AccountApi.deleteUserAddress(id, this.selectedCustomer.id).then(
        (response) => {
          if (response.getErrors([]).length > 0) {
            alert('Ocorreu um problema com o processo.');
            return false;
          }

          this.getAddresses(this.selectedCustomer.id);
        }
      );
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      configurations: (state) => state.store.configurations,
    }),
    esDataFilter() {
      const queries = [
        {
          range: {
            created_at: {
              gte: this.period[0],
              lte: this.period[1],
            },
          },
        },
        {
          bool: {
            should: this.shouldData,
          },
        },
      ];

      if (this.term != '') {
        const termIsNumber = /^\d+$/.test(this.term);

        if (termIsNumber) {
          queries.push({
            query_string: {
              query: `*${this.term}*`,
              fields: ['phone'],
            },
          });
        } else {
          if (this.term.includes('@')) {
            queries.push({
              query_string: {
                query: `${this.term}`,
                fields: ['email'],
              },
            });
          } else {
            queries.push({
              match_phrase_prefix: {
                name: {
                  query: `*${this.term.toLowerCase()}`,
                  slop: 3,
                  max_expansions: 10,
                },
              },
            });
          }
        }
      }

      return {
        query: [
          {
            index: 'report-customers',
            type: 'query',
            size: this.size,
            from: (this.page - 1) * this.size,
            sort: this.sortData,
            queries: queries,
          },
        ],
      };
    },
  },
  watch: {
    term: Utils.debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping: async function (value) {
      if (!value) {
        await this.search();
      }
    },
    result: {
      deep: true,
      handler(newValue) {
        if (newValue.data.length > 0) {
          this.showContent = true;
        }
      },
    },
  },
};
</script>
<style scoped>
.box-order {
  cursor: pointer;
}
.box-order .header {
  font-size: 16px;
  font-weight: bold;
  color: var(--title-card);
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #494949;
  position: relative;
}
.box-order .customer-verify {
  top: -5px;
  right: 0;
}
.field-title.customer-name {
  color: var(--title-card);
  font-size: 16px;
}
.field-title {
  font-size: 12px;
  color: var(--title-card);
  font-weight: bold;
  line-height: 15px;
}

.field-title + p {
  font-size: 12px;
  color: var(--title-card);
  line-height: 15px;
  margin-top: 10px;
}
.search-box {
  display: flex;
  padding: 7px 20px 2px 20px !important;
}
.tag {
  background: #45484d;
  padding: 5px 10px;
  margin-left: 10px;
  font-weight: 400;
  color: #aaaaab;
  font-size: 14px;
  border-radius: 5px;
  position: relative;
}
.tag.period {
  padding-right: 30px;
}
.tags-mobile .tag {
  margin-left: 0 !important;
  margin-top: 10px;
  padding: 10px 15px;
}
.tags-mobile .tag i {
  float: right;
}
.remove-filter {
  margin-left: 12px;
  font-size: 13px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
}
.toggle-tags {
  margin-right: 10px;
  font-size: 1.3em;
  color: var(--default);
}

.search-loading {
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-loading {
  height: calc(100vh - 280px);
  display: flex;
  justify-content: center;
  align-items: center;
}
.content {
  position: relative;
  height: calc(100% - 280px);
}
.content__title-buttons {
  display: flex;
  position: absolute;
  top: -150px;
  right: 0;
}
.box-negative {
  margin-bottom: -10px;
}
.box-format:nth-child(3n + 2) {
  padding-left: 6px !important;
  padding-right: 6px !important;
}
@media screen and (max-width: 991px) {
  .tag {
    font-size: 12px;
  }
  .tag.period {
    margin-top: 15px;
    width: 100%;
    margin-left: 0;
  }
  .content__title-buttons {
    top: -130px;
  }
}
</style>
